<template>
    <HomeLayout>
        <LoadingSpinner :isLoading="isLoading" />

        <div class="view">
            <div class="page-hero">
                <div class="hero-tag">succour.care/verify</div>
                <div class="hero-title">Care Giver <em>Verification</em></div>
                <div class="hero-sub">This profile has been independently verified by Succour Trust Registry.</div>
            </div>
        </div>
    </HomeLayout>

</template>

<script lang="js">
import HomeLayout from '../Layouts/HomeLayout.vue';
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Request from "@/utils/apiclient.js";


export default {
    components: {
        HomeLayout,
        LoadingSpinner,
    },
    data() {
        return {
            isLoading: false,
        }
    },
    mounted() {
        this.handlePaystackCallback();

    },
    methods: {
        
        handlePaystackCallback() {
            // Paystack sends these in query params
            const reference = this.$route.query.reference || this.$route.query.trxref;

            if (!reference) {
                console.log("No payment reference found");
                this.loading = false;
                return;
            }

            this.reference = reference;

            // Now call backend to verify payment
            this.verifyPayment(reference);
        },
        async verifyPayment(reference) {

            this.isLoading = true;

            const request = new Request(
                `/payments/verify/?reference=${reference}`
            );

            await request.get((res, error) => {

                if (error) {

                    console.error("Verification failed:", error);

                    this.isLoading = false;

                    return;
                }

                console.log("Verification result:", res);

                this.isLoading = false;

                var care_id = res.care_id;

                // this.fetchCargiverDetails(care_id);

                // you can continue flow here
                // e.g. redirect to unlocked report page
                this.$router.push(`/care-giver-detailed-report/${care_id}/${this.reference}`);

            }, false);
        }
    }
}

</script>
<style>
:root {
    --green: #17865F;
    --dkgreen: #0D5C40;
    --mdgreen: #2A9D74;
    --ltgreen: #E8F4EF;
    --bg: #D6EDE2;
    --card: #EEF7F2;
    --pink: #F59CAB;
    --amber: #FF9700;
    --white: #FFFFFF;
    --text: #1A1A1A;
    --muted: #5A7A69;
    --border: #C0DDD0;
    --red: #E74C3C;
    --red-lt: #FEE2E2;
    --orange: #F97316;
    --blue: #2563EB;
    --blue-lt: #EFF6FF;
    --teal: #0F6E56;
    --teal-dark: #085041;
    --teal-light: #E1F5EE;
    --pink-light: #FBEAF0;
    --placeholder: #A8C4B2;
    --radius: 12px;
    --shadow: 0 2px 16px rgba(15, 110, 86, 0.08);
}

html,
body {
    overflow-y: auto !important;
}
</style>

<style lang="css" scoped>
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

body.care-register {
    font-family: 'DM Sans', sans-serif;
    background: var(--bg);
    color: var(--text);
    min-height: 100vh;
}

/* ── SYSTEM NAV ── */
.sys-nav {
    background: var(--dkgreen);
    display: flex;
    align-items: stretch;
    border-bottom: 2px solid rgba(0, 0, 0, 0.15);
    position: sticky;
    top: 0;
    z-index: 200;
    overflow-x: auto;
}

.sys-logo {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 20px;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    flex-shrink: 0;
}

.sys-logo-mark {
    width: 26px;
    height: 26px;
    border-radius: 6px;
    background: var(--pink);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Playfair Display', serif;
    font-size: 13px;
    color: white;
    font-weight: 700;
}

.sys-logo-text {
    font-size: 9px;
    letter-spacing: 3px;
    color: rgba(255, 255, 255, 0.65);
    font-weight: 600;
}

.sys-logo-tm {
    font-size: 6px;
    color: rgba(255, 255, 255, 0.35);
    vertical-align: super;
}

.sys-steps {
    display: flex;
    flex: 1;
    min-width: 0;
}

.sys-step {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 16px;
    cursor: pointer;
    border-bottom: 3px solid transparent;
    transition: 0.2s;
    position: relative;
    flex-shrink: 0;
}

.sys-step:hover {
    background: rgba(255, 255, 255, 0.05);
}

.sys-step.active {
    border-bottom-color: var(--pink);
}

.sys-step.active .step-num {
    background: var(--pink);
    color: white;
}

.sys-step.active .step-label {
    color: white;
}

.sys-step.done .step-num {
    background: rgba(39, 174, 96, 0.3);
    color: #7FD4A6;
}

.sys-step.done .step-label {
    color: rgba(255, 255, 255, 0.6);
}

.doc-preview-wrap {
    margin-top: 16px;
}

.doc-preview-img {
    width: 100%;
    max-width: 220px;
    border-radius: 14px;
    border: 1px solid var(--border);
    object-fit: cover;
}

.pdf-preview {
    padding: 14px;
    border-radius: 12px;
    background: #f3f5f7;
    font-size: 13px;
    border: 1px solid var(--border);
}

.verify-success {
    font-size: 12px;
    color: green;
    margin-top: 6px;
}

.step-num {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.4);
    font-size: 10px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: 0.2s;
}

.step-label {
    font-size: 11px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.4);
    transition: 0.2s;
    white-space: nowrap;
}

.step-arrow {
    color: rgba(255, 255, 255, 0.15);
    font-size: 14px;
    flex-shrink: 0;
}

.sys-badge {
    margin: auto 16px auto auto;
    font-size: 9px;
    letter-spacing: 2px;
    color: rgba(255, 255, 255, 0.3);
    text-transform: uppercase;
    white-space: nowrap;
    flex-shrink: 0;
}

/* ── VIEWS ── */
.view {
    display: block;
}


/* ── SHARED ── */
.page-wrap {
    max-width: 860px;
    margin: 0 auto;
    padding: 36px 24px 80px;
}

.page-hero {
    background: var(--dkgreen);
    padding: 36px 40px 44px;
    text-align: center;
}

.hero-tag {
    display: inline-block;
    font-size: 9px;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: var(--pink);
    border: 1px solid rgba(245, 156, 171, 0.3);
    border-radius: 20px;
    padding: 4px 14px;
    margin-bottom: 12px;
}

.hero-title {
    font-family: 'Playfair Display', serif;
    font-size: 30px;
    color: white;
    font-weight: 700;
    margin-bottom: 8px;
    line-height: 1.25;
}

.hero-title em {
    color: var(--pink);
    font-style: italic;
}

.hero-sub {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.5);
    max-width: 480px;
    margin: 0 auto;
    line-height: 1.6;
}

/* ── PROGRESS BAR ── */
.progress-bar {
    display: flex;
    gap: 0;
    margin-bottom: 28px;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid var(--border);
}

.pb-step {
    flex: 1;
    padding: 10px 14px;
    background: var(--card);
    border-right: 1px solid var(--border);
    display: flex;
    align-items: center;
    gap: 8px;
    transition: 0.3s;
}

.pb-step:last-child {
    border-right: none;
}

.pb-step.active {
    background: var(--green);
}

.pb-step.done {
    background: var(--dkgreen);
}

.pb-num {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.5);
    font-size: 9px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.pb-step.active .pb-num,
.pb-step.done .pb-num {
    background: rgba(255, 255, 255, 0.2);
    color: white;
}

.pb-lbl {
    font-size: 10px;
    color: var(--muted);
}

.pb-step.active .pb-lbl,
.pb-step.done .pb-lbl {
    color: white;
}

/* ── SECTION CARDS ── */
.section-card {
    background: var(--card);
    border: 1px solid var(--border);
    border-radius: 14px;
    padding: 24px 26px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.section-title {
    font-size: 9px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: var(--muted);
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.section-title::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--border);
}

.section-icon {
    width: 28px;
    height: 28px;
    border-radius: 7px;
    background: var(--green);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    flex-shrink: 0;
}

/* ── FORM FIELDS ── */
.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    margin-bottom: 14px;
}

.form-grid-3 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 14px;
    margin-bottom: 14px;
}

.form-grid-1 {
    display: grid;
    grid-template-columns: 1fr;
    gap: 14px;
    margin-bottom: 14px;
}

.field {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.field label {
    font-size: 10px;
    font-weight: 500;
    color: var(--muted);
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

.field label .req {
    color: var(--red);
    margin-left: 2px;
}

.field input,
.field select,
.field textarea {
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    background: white;
    border: 1px solid var(--border);
    border-radius: 9px;
    padding: 10px 13px;
    color: var(--text);
    outline: none;
    transition: 0.2s;
}

.field input:focus,
.field select:focus,
.field textarea:focus {
    border-color: var(--green);
    box-shadow: 0 0 0 3px rgba(23, 134, 95, 0.1);
}

input:disabled {
    background: #f5f5f5;
    cursor: not-allowed;
    opacity: 0.7;
}

.field input.invalid {
    border-color: var(--red);
    background: #FFF5F5;
}

.field textarea {
    resize: vertical;
    min-height: 80px;
}

.field select option {
    background: white;
}

.field-hint {
    font-size: 10px;
    color: var(--muted);
    margin-top: 3px;
}

.field-error {
    font-size: 10px;
    color: var(--red);
    margin-top: 5px;
}

/* ── PHOTO UPLOAD ── */
.photo-upload {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 14px;
}

.photo-preview {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: var(--ltgreen);
    border: 2px solid var(--border);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    flex-shrink: 0;
    overflow: hidden;
    cursor: pointer;
    transition: 0.2s;
}

.photo-preview:hover {
    border-color: var(--green);
}

.photo-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.photo-upload-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid var(--border);
    background: white;
    font-family: 'DM Sans', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: var(--dkgreen);
    cursor: pointer;
    transition: 0.2s;
}

.photo-upload-btn:hover {
    border-color: var(--green);
    background: var(--ltgreen);
}

.photo-upload-hint {
    font-size: 10px;
    color: var(--muted);
    margin-top: 5px;
}

.photo-required-note {
    font-size: 10px;
    color: var(--red);
    margin-top: 5px;
}

/* ── DOCUMENT UPLOAD ── */
.doc-uploaded-card {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px;
    margin-top: 14px;
    border-radius: 16px;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
    transition: 0.25s ease;
}

.doc-uploaded-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.doc-thumb {
    width: 64px;
    height: 64px;
    border-radius: 14px;
    overflow: hidden;
    flex-shrink: 0;
    background: #f3f5f7;
    display: flex;
    align-items: center;
    justify-content: center;
}

.doc-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.pdf-thumb {
    font-size: 28px;
}

.doc-meta {
    flex: 1;
    min-width: 0;
}

.doc-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .08em;
    color: #888;
    margin-bottom: 4px;
}

.doc-name {
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.doc-remove-btn {
    border: none;
    background: #ffe9e9;
    color: #d93025;
    padding: 10px 14px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.2s ease;
}

.doc-remove-btn:hover {
    background: #ffd6d6;
}

.doc-upload-zone {
    border: 2px dashed var(--border);
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: 0.2s;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.doc-upload-zone:hover,
.doc-upload-zone.drag {
    border-color: var(--green);
    background: var(--ltgreen);
}

.doc-icon {
    font-size: 24px;
}

.doc-upload-label {
    font-size: 12px;
    font-weight: 500;
    color: var(--dkgreen);
}

.doc-upload-sub {
    font-size: 10px;
    color: var(--muted);
}

.doc-upload-zone input[type=file] {
    display: none;
}

.doc-uploaded {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    background: var(--ltgreen);
    border: 1px solid var(--border);
    border-radius: 8px;
    margin-top: 8px;
}

.doc-uploaded-name {
    font-size: 12px;
    color: var(--dkgreen);
    font-weight: 500;
    flex: 1;
}

.doc-remove {
    font-size: 10px;
    color: var(--red);
    cursor: pointer;
    font-weight: 600;
}

/* camera / upload dual option */
.dual-upload {
    display: flex;
    gap: 10px;
    margin-bottom: 8px;
}

.dual-btn {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 14px 10px;
    border-radius: 10px;
    border: 1.5px dashed var(--border);
    background: white;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    font-size: 11px;
    font-weight: 500;
    color: var(--dkgreen);
    transition: 0.2s;
}

.dual-btn:hover {
    border-color: var(--green);
    background: var(--ltgreen);
}

.dual-btn span {
    font-size: 22px;
}

.section-label {
    font-size: 10px;
    font-weight: 600;
    color: #6B8F78;
    letter-spacing: .07em;
    text-transform: uppercase;
    margin-bottom: 12px;
}

.id-types {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    margin-bottom: 14px;
}

.id-type-btn {
    background: #fff;
    border: 1px solid #D0E3D8;
    border-radius: 9px;
    padding: 13px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 7px;
    color: #6B8F78;
    font-size: 12px;
    text-align: center;
    cursor: pointer;
    transition: .2s;
    user-select: none;
}

.id-type-btn:hover {
    border-color: #17865F;
    color: #17865F;
}

.id-type-btn.active {
    border-color: #17865F;
    color: #17865F;
    background: #E8F4EF;
}

.id-type-btn .cb {
    width: 14px;
    height: 14px;
    border: 1.5px solid currentColor;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.id-type-btn.active .cb {
    background: #17865F;
    border-color: #17865F;
}

.id-type-btn.active .cb::after {
    content: '✓';
    font-size: 9px;
    color: #fff;
    line-height: 1;
}

.word-count {
    font-size: 12px;
    color: #777;
    margin-top: 4px;
    text-align: right;
}

.field-label {
    font-size: 10px;
    font-weight: 600;
    color: #6B8F78;
    letter-spacing: .07em;
    text-transform: uppercase;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    gap: 3px;
}

.divider {
    border: none;
    border-top: 1px solid #E2EDE7;
    margin: 18px 0;
}

/* ── REFERENCE ROWS ── */
.ref-row {
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    gap: 10px;
    align-items: end;
    margin-bottom: 10px;
    background: white;
    padding: 12px;
    border-radius: 9px;
    border: 1px solid var(--border);
}

.ref-row-num {
    font-size: 10px;
    font-weight: 600;
    color: var(--muted);
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 4px;
}

.ref-remove-btn {
    width: 30px;
    height: 36px;
    margin-left: auto;
    border-radius: 8px;
    border: 1px solid var(--border);
    background: white;
    color: var(--red);
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s;
    align-self: flex-end;
}

.ref-remove-btn:hover {
    background: var(--red-lt);
}

.add-ref-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px dashed var(--green);
    background: var(--ltgreen);
    font-family: 'DM Sans', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: var(--dkgreen);
    cursor: pointer;
    transition: 0.2s;
    margin-top: 4px;
}

.add-ref-btn:hover {
    background: var(--card);
}

/* ── EMPLOYMENT HISTORY ROWS ── */
.emp-history-row {
    background: white;
    padding: 14px 16px;
    border-radius: 9px;
    border: 1px solid var(--border);
    margin-bottom: 10px;
}

.emp-row-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.emp-row-num {
    font-size: 10px;
    font-weight: 600;
    color: var(--muted);
    text-transform: uppercase;
    letter-spacing: 1px;
}

.emp-row-remove {
    font-size: 11px;
    color: var(--red);
    cursor: pointer;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 5px;
    border: 1px solid var(--red);
    background: transparent;
    font-family: 'DM Sans', sans-serif;
    transition: 0.2s;
}

.emp-row-remove:hover {
    background: var(--red-lt);
}

.add-emp-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px dashed var(--green);
    background: var(--ltgreen);
    font-family: 'DM Sans', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: var(--dkgreen);
    cursor: pointer;
    transition: 0.2s;
    margin-top: 4px;
}

.add-emp-btn:hover {
    background: var(--card);
}

/* ── CATEGORY TOGGLES ── */
.cat-grid {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.cat-toggle {
    padding: 8px 16px;
    border-radius: 20px;
    border: 1px solid var(--border);
    background: white;
    font-size: 12px;
    font-weight: 500;
    color: var(--muted);
    cursor: pointer;
    transition: 0.2s;
    user-select: none;
}

.cat-toggle.selected {
    background: var(--green);
    border-color: var(--green);
    color: white;
}

/* ── CONSENT BOX ── */
.consent-box {
    background: white;
    border: 1.5px solid var(--border);
    border-radius: 10px;
    padding: 16px 18px;
    margin-bottom: 16px;
}

.consent-inner {
    display: flex;
    gap: 12px;
    align-items: flex-start;
}

.consent-inner input[type=checkbox] {
    width: 18px;
    height: 18px;
    margin-top: 2px;
    flex-shrink: 0;
    accent-color: var(--green);
    cursor: pointer;
}

.consent-text {
    font-size: 12px;
    color: var(--text);
    line-height: 1.6;
}

.consent-text strong {
    color: var(--dkgreen);
}

/* ── SUBMIT BTN ── */
.submit-btn {
    width: 100%;
    padding: 15px;
    border-radius: 10px;
    border: none;
    background: var(--green);
    color: white;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 0.5px;
    transition: 0.2s;
    margin-top: 8px;
}

.submit-btn:hover {
    background: var(--mdgreen);
}

.submit-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* ── SUCCESS STATE ── */
.success-state {
    text-align: center;
    padding: 48px 24px;
}

.success-state.show {
    display: block;
    animation: fadeUp 0.4s ease;
}

.success-icon {
    font-size: 48px;
    margin-bottom: 16px;
}

.success-title {
    font-family: 'Playfair Display', serif;
    font-size: 24px;
    color: var(--dkgreen);
    margin-bottom: 8px;
}

.success-sub {
    font-size: 13px;
    color: var(--muted);
    max-width: 400px;
    margin: 0 auto 24px;
    line-height: 1.6;
}

.back-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    margin-bottom: 16px;
    border: none;
    border-radius: 10px;
    background: #ffffff;
    color: #1f2937;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
    transition: all .2s ease;
}

.back-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.10);
}

.back-btn:active {
    transform: translateY(0);
}

.back-btn-icon {
    font-size: 16px;
    line-height: 1;
}

.success-ref {
    font-family: 'DM Mono', monospace;
    font-size: 13px;
    color: var(--green);
    background: var(--ltgreen);
    padding: 8px 20px;
    border-radius: 8px;
    border: 1px solid var(--border);
    display: inline-block;
}

/* ── OPS QUEUE ── */
.ops-banner {
    background: #FFFBEB;
    border: 1px solid rgba(255, 151, 0, 0.3);
    border-radius: 10px;
    padding: 12px 18px;
    margin-bottom: 20px;
    font-size: 11px;
    color: #92400E;
    display: flex;
    align-items: center;
    gap: 8px;
}

.queue-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}

.queue-table th {
    font-size: 9px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: var(--muted);
    padding: 10px 12px;
    text-align: left;
    border-bottom: 2px solid var(--border);
}

.queue-table td {
    font-size: 12px;
    color: var(--text);
    padding: 12px 12px;
    border-bottom: 1px solid var(--border);
    vertical-align: middle;
}

.queue-table tr:hover td {
    background: var(--ltgreen);
}

.status-pill {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 1px;
    padding: 3px 10px;
    border-radius: 20px;
}

.status-pill.pending {
    background: #FFFBEB;
    color: #92400E;
    border: 1px solid rgba(255, 151, 0, 0.25);
}

.status-pill.in-progress {
    background: rgba(37, 99, 235, 0.08);
    color: #1D4ED8;
    border: 1px solid rgba(37, 99, 235, 0.2);
}

.status-pill.complete {
    background: #E8F7F0;
    color: var(--green);
    border: 1px solid rgba(23, 134, 95, 0.2);
}

.review-btn {
    font-size: 11px;
    font-weight: 600;
    padding: 5px 14px;
    border-radius: 7px;
    border: 1px solid var(--border);
    background: white;
    color: var(--dkgreen);
    cursor: pointer;
    transition: 0.2s;
}

.review-btn:hover {
    background: var(--ltgreen);
    border-color: var(--green);
}

/* ── OPS VERIFICATION PANEL ── */
.ops-profile {
    background: white;
    border: 1px solid var(--border);
    border-radius: 14px;
    padding: 20px 22px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 16px;
}

.ops-av {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--green), #2CC89A);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Playfair Display', serif;
    font-size: 20px;
    color: white;
    font-weight: 700;
    flex-shrink: 0;
    overflow: hidden;
}

.ops-av img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.ops-profile-name {
    font-family: 'Playfair Display', serif;
    font-size: 17px;
    color: var(--dkgreen);
}

.ops-profile-meta {
    font-size: 11px;
    color: var(--muted);
    margin-top: 3px;
}

.ops-profile-ref {
    font-family: 'DM Mono', monospace;
    font-size: 10px;
    color: var(--muted);
    margin-top: 2px;
}

/* API badge */
.api-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 1px;
    padding: 3px 9px;
    border-radius: 20px;
    margin-left: 8px;
}

.api-badge.auto {
    background: rgba(37, 99, 235, 0.08);
    color: #1D4ED8;
    border: 1px solid rgba(37, 99, 235, 0.2);
}

.api-badge.manual {
    background: #FFFBEB;
    color: #92400E;
    border: 1px solid rgba(255, 151, 0, 0.3);
}

/* signals */
.sig-block {
    background: white;
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 18px 20px;
    margin-bottom: 14px;
}

.sig-block-title {
    font-size: 9px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: var(--muted);
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.sig-block-title::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--border);
}

.sig-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 9px 0;
    border-bottom: 1px solid var(--border);
}

.sig-row:last-child {
    border: none;
    padding-bottom: 0;
}

.sig-left {
    flex: 1;
}

.sig-name {
    font-size: 12px;
    font-weight: 500;
    color: var(--text);
}

.sig-sub {
    font-size: 10px;
    color: var(--muted);
    margin-top: 2px;
}

.sig-doc {
    font-size: 10px;
    color: var(--green);
    text-decoration: underline;
    cursor: pointer;
    margin-top: 2px;
}

.sig-select {
    font-family: 'DM Sans', sans-serif;
    font-size: 12px;
    background: var(--card);
    border: 1px solid var(--border);
    border-radius: 7px;
    padding: 6px 10px;
    color: var(--text);
    outline: none;
    min-width: 200px;
    cursor: pointer;
}

.sig-select:focus {
    border-color: var(--green);
}

.sig-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
}

/* reputation counters */
.rep-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
    margin-top: 8px;
}

.rep-counter {
    background: var(--card);
    border: 1px solid var(--border);
    border-radius: 10px;
    padding: 10px 12px;
    text-align: center;
}

.rep-counter-label {
    font-size: 9px;
    font-weight: 600;
    color: var(--muted);
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 8px;
}

.rep-ctrl {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.rev-btn {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 1px solid var(--border);
    background: white;
    color: var(--green);
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.15s;
}

.rev-btn:hover {
    background: var(--ltgreen);
    border-color: var(--green);
}

.rev-count {
    font-size: 16px;
    font-weight: 700;
    color: var(--dkgreen);
    min-width: 22px;
    text-align: center;
}

/* NPF upload */
.npf-upload {
    margin-top: 10px;
    display: none;
}

.npf-upload.show {
    display: block;
}

/* compute */
.compute-btn {
    width: 100%;
    padding: 14px;
    border-radius: 10px;
    border: none;
    background: var(--green);
    color: white;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 0.5px;
    transition: 0.2s;
    margin-top: 4px;
}

.compute-btn:hover {
    background: var(--mdgreen);
}

/* DNE banner */
.dne-banner {
    background: #FEE2E2;
    border: 2px solid var(--red);
    border-radius: 12px;
    padding: 20px 22px;
    margin-top: 14px;
    display: none;
    animation: fadeUp 0.35s ease;
}

.dne-banner.show {
    display: block;
}

.dne-title {
    font-family: 'Playfair Display', serif;
    font-size: 18px;
    color: var(--red);
    font-weight: 700;
    margin-bottom: 6px;
}

.dne-sub {
    font-size: 13px;
    color: #7F1D1D;
    line-height: 1.6;
}

/* score result */
.score-result {
    display: none;
    background: var(--dkgreen);
    border-radius: 14px;
    padding: 24px 26px;
    margin-top: 14px;
}

.score-result.show {
    display: block;
    animation: fadeUp 0.35s ease;
}

.sr-top {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
}

.sr-num {
    font-family: 'Playfair Display', serif;
    font-size: 56px;
    color: white;
    line-height: 1;
    font-weight: 700;
}

.sr-denom {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.35);
    margin-top: 4px;
}

.sr-tier {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 1px;
    padding: 5px 16px;
    border-radius: 20px;
    display: inline-block;
    margin-bottom: 6px;
}

.sr-tier.unverified {
    background: rgba(231, 76, 60, 0.2);
    color: #FCA5A5;
    border: 1px solid rgba(231, 76, 60, 0.3);
}

.sr-tier.bronze {
    background: rgba(255, 151, 0, 0.2);
    color: var(--amber);
    border: 1px solid rgba(255, 151, 0, 0.3);
}

.sr-tier.silver {
    background: rgba(200, 230, 215, 0.2);
    color: #A7D4BE;
    border: 1px solid rgba(200, 230, 215, 0.3);
}

.sr-tier.gold {
    background: rgba(255, 215, 0, 0.15);
    color: #FFD700;
    border: 1px solid rgba(255, 215, 0, 0.25);
}

.sr-deploy {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.45);
}

.sr-checklist {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.sr-check {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 10px;
    border-radius: 7px;
    background: rgba(255, 255, 255, 0.05);
}

.sr-ck-icon {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    flex-shrink: 0;
}

.sr-ck-icon.ok {
    background: rgba(39, 174, 96, 0.25);
    color: #7FD4A6;
}

.sr-ck-icon.fail {
    background: rgba(231, 76, 60, 0.2);
    color: #FCA5A5;
}

.sr-ck-lbl {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.6);
}

.issue-btn {
    width: 100%;
    padding: 13px;
    border-radius: 10px;
    border: none;
    background: var(--pink);
    color: white;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 0.5px;
    transition: 0.2s;
    margin-top: 12px;
}

.issue-btn:hover {
    background: #e08a99;
}

/* ── EMPLOYER VIEW (standard) ── */
.ev-card {
    background: white;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
    max-width: 480px;
    margin: 0 auto;
}

.ev-stripe {
    height: 5px;
    background: linear-gradient(90deg, var(--green), #2CC89A, var(--pink));
}

.ev-body {
    padding: 24px 26px;
}

.ev-hdr {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 18px;
    padding-bottom: 16px;
    border-bottom: 1px solid #EEF4F1;
}

.ev-photo {
    width: 52px;
    height: 52px;
    border-radius: 10px;
    background: linear-gradient(135deg, var(--green), #2CC89A);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Playfair Display', serif;
    font-size: 20px;
    color: white;
    font-weight: 700;
    flex-shrink: 0;
    overflow: hidden;
}

.ev-photo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.ev-name {
    font-family: 'Playfair Display', serif;
    font-size: 17px;
    color: var(--text);
    font-weight: 700;
}

.ev-sc {
    font-family: 'DM Mono', monospace;
    font-size: 10px;
    color: var(--muted);
    margin-top: 3px;
}

.ev-tbadge {
    margin-left: auto;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
    padding: 5px 14px;
    border-radius: 20px;
    text-transform: capitalize;
}

.ev-tbadge.gold {
    background: rgba(255, 215, 0, 0.1);
    color: #B8860B;
    border: 1px solid rgba(255, 215, 0, 0.25);
}

.ev-tbadge.silver {
    background: var(--ltgreen);
    color: var(--dkgreen);
    border: 1px solid rgba(23, 134, 95, 0.2);
}

.ev-tbadge.bronze {
    background: #FFFBEB;
    color: #92400E;
    border: 1px solid rgba(255, 151, 0, 0.2);
}

.ev-score-block {
    display: flex;
    align-items: center;
    gap: 14px;
    background: var(--ltgreen);
    border-radius: 12px;
    padding: 14px 18px;
    margin-bottom: 18px;
    border: 1px solid rgba(23, 134, 95, 0.12);
}

.ev-score-num {
    font-family: 'Playfair Display', serif;
    font-size: 46px;
    color: var(--dkgreen);
    line-height: 1;
    font-weight: 700;
}

.ev-score-denom {
    font-size: 12px;
    color: var(--muted);
}

.ev-score-level {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1px;
    padding: 3px 12px;
    border-radius: 20px;
    margin-top: 4px;
    text-transform: capitalize;
}

.ev-score-level.gold {
    background: rgba(255, 215, 0, 0.1);
    color: #B8860B;
    border: 1px solid rgba(255, 215, 0, 0.2);
}

.ev-score-level.silver {
    background: rgba(23, 134, 95, 0.1);
    color: var(--green);
    border: 1px solid rgba(23, 134, 95, 0.2);
}

.ev-score-level.bronze {
    background: #FFFBEB;
    color: #92400E;
    border: 1px solid rgba(255, 151, 0, 0.15);
}

.ev-cats-lbl {
    font-size: 8px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: var(--muted);
    margin-bottom: 7px;
}

.ev-cats {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    margin-bottom: 16px;
}

.ev-cat {
    font-size: 10px;
    color: var(--dkgreen);
    font-weight: 500;
    background: var(--ltgreen);
    border: 1px solid var(--border);
    padding: 4px 10px;
    border-radius: 20px;
}

.ev-br-lbl {
    font-size: 8px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: var(--muted);
    margin-bottom: 10px;
}

.ev-row-item {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 8px;
}

.ev-rl {
    font-size: 11px;
    color: var(--text);
    width: 100px;
    flex-shrink: 0;
}

.ev-bar-track {
    flex: 1;
    height: 6px;
    background: #EEF4F1;
    border-radius: 6px;
    overflow: hidden;
}

.ev-bar-fill {
    height: 100%;
    border-radius: 6px;
}

.ev-bar-fill.excellent {
    background: var(--green);
    width: 92%;
}

.ev-bar-fill.good {
    background: var(--amber);
    width: 70%;
}

.ev-bar-fill.average {
    background: #F0A05A;
    width: 48%;
}

.ev-bar-fill.poor {
    background: var(--red);
    width: 24%;
}

.ev-rval {
    font-size: 10px;
    font-weight: 600;
    width: 58px;
    text-align: right;
}

.ev-rval.excellent {
    color: var(--green);
}

.ev-rval.good {
    color: #B36800;
}

.ev-rval.average {
    color: #E07020;
}

.ev-rval.poor {
    color: var(--red);
}

.ev-status {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 11px 14px;
    background: #E8F7F0;
    border-radius: 10px;
    border: 1px solid rgba(23, 134, 95, 0.2);
    margin: 14px 0;
}

.ev-sdot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--green);
    flex-shrink: 0;
    animation: pulse 2s infinite;
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1
    }

    50% {
        opacity: 0.5
    }
}

.ev-stext {
    font-size: 12px;
    color: var(--dkgreen);
    font-weight: 600;
}

.ev-sdate {
    font-size: 10px;
    color: var(--muted);
    margin-left: auto;
}

.ev-qr-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 14px;
    border-top: 1px solid #EEF4F1;
}

.ev-qr-box {
    width: 60px;
    height: 60px;
    background: var(--ltgreen);
    border-radius: 8px;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ev-share-btns {
    display: flex;
    gap: 8px;
}

.ev-share-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    font-size: 11px;
    font-weight: 600;
    transition: 0.2s;
}

.ev-share-btn.wa {
    background: #25D366;
    color: white;
}

.ev-share-btn.wa:hover {
    background: #1DA851;
}

.ev-share-btn.copy {
    background: var(--ltgreen);
    color: var(--dkgreen);
    border: 1px solid var(--border);
}

.ev-share-btn.copy:hover {
    background: #D0EBE0;
}

.ev-footer-lnk {
    font-size: 9px;
    color: var(--muted);
    text-align: center;
    margin-top: 12px;
}

.ev-footer-lnk a {
    color: var(--green);
    font-weight: 600;
    text-decoration: none;
}

.phone-row {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.same-check {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    cursor: pointer;
}

/* ── DETAILED EMPLOYER VIEW (payment gated) ── */
.pay-gate {
    background: var(--dkgreen);
    border-radius: 16px;
    overflow: hidden;
    max-width: 560px;
    margin: 0 auto 20px;
}

.pay-gate-body {
    padding: 32px;
}

.pay-gate-icon {
    font-size: 36px;
    margin-bottom: 12px;
}

.pay-gate-title {
    font-family: 'Playfair Display', serif;
    font-size: 22px;
    color: white;
    margin-bottom: 8px;
}

.pay-gate-sub {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.55);
    line-height: 1.6;
    margin-bottom: 24px;
}

.pay-features {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 24px;
}

.pay-feature {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
}

.pay-feature-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--pink);
    flex-shrink: 0;
}

.pay-price {
    display: flex;
    align-items: baseline;
    gap: 6px;
    margin-bottom: 20px;
}

.pay-amount {
    font-family: 'Playfair Display', serif;
    font-size: 32px;
    color: white;
    font-weight: 700;
}

.pay-period {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.45);
}

.pay-btn {
    width: 100%;
    padding: 14px;
    border-radius: 10px;
    border: none;
    background: var(--pink);
    color: white;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 0.5px;
    transition: 0.2s;
}

.pay-btn:hover {
    background: #e08a99;
}

.pay-note {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.3);
    text-align: center;
    margin-top: 10px;
}

/* detailed report */
.det-report {
    background: white;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
    max-width: 600px;
    margin: 0 auto;
    animation: fadeUp 0.4s ease;
}

.det-report.show {
    display: block;
}

.det-header {
    background: var(--dkgreen);
    padding: 24px 26px;
    display: flex;
    align-items: center;
    gap: 14px;
}

.det-photo {
    width: 56px;
    height: 56px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Playfair Display', serif;
    font-size: 22px;
    color: white;
    flex-shrink: 0;
    overflow: hidden;
}

.det-photo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.det-title {
    font-family: 'Playfair Display', serif;
    font-size: 18px;
    color: white;
    font-weight: 700;
}

.det-sub {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.5);
    margin-top: 3px;
}

.det-badge {
    margin-left: auto;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
    padding: 5px 14px;
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
}

.det-body {
    padding: 24px 26px;
}

.det-section {
    margin-bottom: 22px;
}

.det-section-title {
    font-size: 8px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: var(--muted);
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.det-section-title::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--border);
}

.det-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 0;
    border-bottom: 1px solid var(--border);
    font-size: 12px;
}

.det-row:last-child {
    border: none;
}

.det-key {
    color: var(--muted);
}

.det-val {
    font-weight: 500;
    color: var(--text);
}

.det-status {
    font-size: 10px;
    font-weight: 700;
    padding: 3px 9px;
    border-radius: 20px;
}

.det-status.verified {
    background: #E8F7F0;
    color: var(--green);
    border: 1px solid rgba(23, 134, 95, 0.2);
}

.det-status.not-verified {
    background: #FFFBEB;
    color: #92400E;
    border: 1px solid rgba(255, 151, 0, 0.3);
}

.det-status.forged {
    background: var(--red-lt);
    color: var(--red);
    border: 1px solid rgba(231, 76, 60, 0.3);
}

.det-status.clear {
    background: #E8F7F0;
    color: var(--green);
    border: 1px solid rgba(23, 134, 95, 0.2);
}

.det-status.record {
    background: var(--red-lt);
    color: var(--red);
    border: 1px solid rgba(231, 76, 60, 0.3);
}

.det-status.positive {
    background: #E8F7F0;
    color: var(--green);
    border: 1px solid rgba(23, 134, 95, 0.2);
}

.det-status.negative {
    background: var(--red-lt);
    color: var(--red);
    border: 1px solid rgba(231, 76, 60, 0.3);
}

.det-warning {
    background: var(--red-lt);
    border: 1px solid rgba(231, 76, 60, 0.3);
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 11px;
    color: #7F1D1D;
    margin-top: 12px;
}

/* ── CARE ID ── */
.cid-cat {
    font-size: 8px;
    font-weight: 500;
    padding: 3px 8px;
    border-radius: 20px;
}

.cid-cat-dark {
    color: rgba(255, 255, 255, 0.55);
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.12);
}

.cid-cat-light {
    color: var(--dkgreen);
    background: var(--ltgreen);
    border: 1px solid var(--border);
}

.cid-share-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 9px 10px;
    border-radius: 9px;
    border: none;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    font-size: 11px;
    font-weight: 600;
    transition: 0.18s;
}

.cid-share-btn.wa {
    background: #25D366;
    color: white;
}

.cid-share-btn.wa:hover {
    background: #1DA851;
}

.cid-share-btn.copy {
    background: white;
    color: var(--dkgreen);
    border: 1px solid var(--border);
}

.cid-share-btn.copy:hover {
    background: var(--ltgreen);
}

.upload-hint {
    background: #E8F4EF;
    border: 1px solid #C0DDD0;
    border-radius: 8px;
    padding: 10px 14px;
    display: flex;
    gap: 8px;
    align-items: flex-start;
    margin-top: 10px;
}

.upload-hint i {
    color: #17865F;
    font-size: 14px;
    flex-shrink: 0;
    margin-top: 1px;
}

.upload-hint span {
    font-size: 12px;
    color: #17865F;
    line-height: 1.5;
}

.dl-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 10px 16px;
    background: #fff;
    border: 1px solid #D0E3D8;
    border-radius: 9px;
    color: #17865F;
    font-size: 13px;
    font-weight: 600;
    font-family: 'Open Sans', sans-serif;
    cursor: pointer;
    transition: .2s;
    margin-top: 10px;
}

.dl-btn:hover {
    background: #E8F4EF;
    border-color: #17865F;
}

.dl-btn i {
    font-size: 16px;
}

.format-hint {
    font-size: 10px;
    color: #9CB8A6;
    margin-top: 5px;
}

/* ── UTILITIES ── */
@keyframes fadeUp {
    from {
        opacity: 0;
        transform: translateY(8px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.notice {
    padding: 14px 18px;
    border-radius: 10px;
    font-size: 12px;
    line-height: 1.6;
    margin-bottom: 16px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.notice.info {
    background: rgba(37, 99, 235, 0.06);
    border: 1px solid rgba(37, 99, 235, 0.15);
    color: #1D4ED8;
}

.notice.warn {
    background: #FFFBEB;
    border: 1px solid rgba(255, 151, 0, 0.3);
    color: #92400E;
}

.notice.danger {
    background: var(--red-lt);
    border: 1px solid rgba(231, 76, 60, 0.3);
    color: #7F1D1D;
}

/* OTP MODAL */
.overlay {
    position: fixed;
    inset: 0;
    background: rgba(10, 30, 20, 0.55);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    z-index: 200;
    opacity: 0;
    pointer-events: none;
    transition: opacity .25s;
}

.overlay.show {
    opacity: 1;
    pointer-events: all;
}

.modal {
    background: #fff;
    width: 100%;
    max-width: 460px;
    border-radius: 24px 24px 0 0;
    padding: 0;
    box-shadow: 0 -8px 40px rgba(15, 110, 86, 0.18);
    transform: translateY(100%);
    transition: transform .32s cubic-bezier(0.32, 0.72, 0, 1);
    overflow: hidden;
    max-height: 95vh;
    overflow-y: auto;
}

.overlay.show .modal {
    transform: translateY(0);
}

.modal-handle {
    display: flex;
    justify-content: center;
    padding: 12px 0 4px;
}

.modal-handle-bar {
    width: 36px;
    height: 4px;
    border-radius: 2px;
    background: var(--border);
}

.modal-topbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 4px 16px 0;
}

.modal-close-btn {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: none;
    background: var(--bg);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background .15s;
    -webkit-tap-highlight-color: transparent;
}

.modal-close-btn:hover {
    background: var(--border);
}

.modal-close-btn svg {
    width: 14px;
    height: 14px;
    stroke: var(--muted);
    fill: none;
    stroke-width: 2.5;
    stroke-linecap: round;
}

.modal-body {
    padding: 12px 24px 32px;
}

@supports(padding-bottom:env(safe-area-inset-bottom)) {
    .modal-body {
        padding-bottom: calc(32px + env(safe-area-inset-bottom));
    }
}

.modal-icon {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    background: var(--teal-light);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 14px;
}

.modal-icon svg {
    width: 24px;
    height: 24px;
    stroke: var(--teal);
    fill: none;
    stroke-width: 1.8;
}


.modal-title {
    font-family: 'DM Serif Display', serif;
    font-size: 22px;
    text-align: center;
    color: var(--text);
    margin-bottom: 6px;
    line-height: 1.2;
}

.modal-sub {
    font-size: 13px;
    color: var(--muted);
    text-align: center;
    line-height: 1.6;
    margin-bottom: 22px;
}

.modal-sub strong {
    color: var(--teal);
    font-weight: 600;
    word-break: break-all;
}

/* EMAIL VERIFIED */
.email-verified {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 11px;
    color: #3BAF7A;
    font-weight: 600;
    margin-top: 4px;
}

.email-verified svg {
    width: 13px;
    height: 13px;
    stroke: #3BAF7A;
    fill: none;
    stroke-width: 2.5;
}

.otp-row {
    display: flex;
    gap: 8px;
    justify-content: center;
    margin-bottom: 35px;
}

.otp-box {
    flex: 1;
    max-width: 52px;
    height: 56px;
    border: 2px solid var(--border);
    border-radius: 10px;
    text-align: center;
    font-size: 22px;
    font-weight: 700;
    font-family: 'DM Serif Display', serif;
    color: var(--text);
    outline: none;
    transition: border-color .15s, box-shadow .15s;
    background: #fff;
    -webkit-appearance: none;
    min-height: 44px;
}

.otp-box:focus {
    border-color: var(--teal);
    box-shadow: 0 0 0 3px rgba(15, 110, 86, 0.12);
}

.otp-box.filled {
    border-color: var(--teal);
    background: var(--teal-light);
}

.otp-box.error-box {
    border-color: var(--pink);
    animation: shake .35s ease;
}

@keyframes shake {

    0%,
    100% {
        transform: translateX(0)
    }

    25% {
        transform: translateX(-6px)
    }

    75% {
        transform: translateX(6px)
    }
}

.otp-error {
    font-size: 12px;
    color: #D4537E;
    text-align: center;
    margin-bottom: 10px;
    min-height: 16px;
    font-weight: 500;
}

.verify-btn {
    width: 100%;
    background: var(--teal);
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    font-family: 'DM Sans', sans-serif;
    cursor: pointer;
    transition: background .15s;
    min-height: 50px;
    -webkit-tap-highlight-color: transparent;
}

.verify-btn:hover {
    background: var(--teal-dark);
}

.verify-btn:disabled {
    background: var(--border);
    color: var(--placeholder);
    cursor: not-allowed;
}

.resend-row {
    text-align: center;
    margin-top: 14px;
    font-size: 12px;
    color: var(--muted);
    line-height: 1.8;
}

.resend-btn {
    background: none;
    border: none;
    color: var(--teal);
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    padding: 0;
    -webkit-tap-highlight-color: transparent;
}

.resend-btn:disabled {
    color: var(--placeholder);
    cursor: not-allowed;
}

.demo-hint {
    margin-top: 12px;
    text-align: center;
    font-size: 11px;
    color: var(--placeholder);
}

.modal-success {
    text-align: center;
}

.success-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: var(--teal-light);
    border: 3px solid var(--teal);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 14px;
}

.success-icon svg {
    width: 28px;
    height: 28px;
    stroke: var(--teal);
    fill: none;
    stroke-width: 2.5;
}

.success-title {
    font-family: 'DM Serif Display', serif;
    font-size: 22px;
    color: var(--text);
    margin-bottom: 6px;
}

.section-hint {
    color: var(--red);
    font-size: 11px;
    margin-left: 6px;
}

.success-sub {
    font-size: 13px;
    color: var(--muted);
    line-height: 1.6;
    margin-bottom: 24px;
}

.continue-btn {
    width: 100%;
    background: var(--teal);
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    font-family: 'DM Sans', sans-serif;
    cursor: pointer;
    min-height: 50px;
    -webkit-tap-highlight-color: transparent;
}

.continue-btn:hover {
    background: var(--teal-dark);
}

/* RESPONSIVE */
@media(min-width:600px) {
    .nav-url {
        display: block;
    }

    .overlay {
        align-items: center;
    }

    .modal {
        border-radius: 20px;
        transform: translateY(20px) scale(0.97);
    }

    .overlay.show .modal {
        transform: translateY(0) scale(1);
    }

    .modal-handle {
        display: none;
    }

    .modal-body {
        padding: 12px 32px 36px;
    }
}

@media(min-width:480px) and (max-width:719px) {
    .main {
        padding: 16px 14px 96px;
    }
}

@media (max-width: 768px) {
    .ref-row {
        grid-template-columns: 1fr;
        /* stack items */
        gap: 8px;
        align-items: stretch;
    }

    .dl-btn {
        font-size: 11px;
    }

    .progress-bar {
        margin-bottom: 16px;
        border-radius: 8px;
    }

    .pb-step {
        width: 100%;
        border-right: none;
        border-bottom: 1px solid var(--border);
    }

    .pb-lbl {
        font-size: 8.5px;
    }


}

@media(max-width:479px) {
    .section-hint {
        font-size: 8px;
        margin-left: 0;
    }

    .nav-name {
        font-size: 13px;
    }

    .steps {
        margin-left: 10px;
    }

    .step {
        padding: 0 8px;
        font-size: 10px;
        gap: 4px;
    }

    .step-sep {
        display: none;
    }

    .mobile-step-bar {
        display: flex;
    }

    .main {
        padding: 14px 12px 90px;
    }

    .card-header {
        padding: 12px 14px 10px;
    }

    .card-body {
        padding: 14px;
    }

    .form-grid {
        grid-template-columns: 1fr;
        gap: 10px;
    }

    .form-group.full {
        grid-column: 1;
    }

    .photo-circle {
        width: 60px;
        height: 60px;
    }

    .upload-photo-btn {
        width: 100%;
        justify-content: center;
    }

    .id-types {
        grid-template-columns: repeat(2, 1fr);
    }

    .otp-row {
        gap: 6px;
    }

    .otp-box {
        height: 52px;
        width: 15px;
        font-size: 20px;
        max-width: none;
    }

    .modal-body {
        padding: 8px 16px 28px;
    }

    .modal-title {
        font-size: 20px;
    }
}

@media(max-width:359px) {
    .otp-row {
        gap: 4px;
    }

    .otp-box {
        height: 48px;
        width: 15px;
        font-size: 18px;
        border-radius: 8px;
    }

    .step .num {
        display: none;
    }
}
</style>